export default __webpack_public_path__ + "static/BAP_4392-Verbessert-NR_rgb_fine-bdd298c0915f2d5cbdf7ce2a7c39c32e.jpg";